import { Link } from '@tanstack/react-router'
import { ChevronLeft } from 'lucide-react'

const backButtonClass =
  'inline-flex items-center gap-1.5 rounded-full bg-black/[0.13] pl-3 pr-3.5 py-1.5 text-sm font-medium text-black hover:bg-black/[0.18] transition-colors no-underline'

type BackButtonProps =
  | { to: string; onClick?: never; children: string }
  | { to?: never; onClick: () => void; children: string }

export function BackButton({ to, onClick, children }: BackButtonProps) {
  if (to) {
    return (
      <Link to={to} preload="intent" className={backButtonClass}>
        <ChevronLeft className="w-5 h-5" />
        {children}
      </Link>
    )
  }

  return (
    <button type="button" onClick={onClick} className={backButtonClass}>
      <ChevronLeft className="w-5 h-5" />
      {children}
    </button>
  )
}
